<div class="checkbox">
  <ng-content></ng-content>
  <i *ngIf="checked" class="material-icons">check</i>
</div>
<div *ngIf="label" class="label">
  {{ label }}
</div>
